// extracted by mini-css-extract-plugin
export default {"container":"Products_container__J7pug","products":"Products_products__-ZEbV","menu":"Products_menu__Eixrd","list":"Products_list__OKrye","product":"Products_product__KMwyF"};